/**
 * Frontend Hooks
 *
 * Exports all frontend hooks.
 *
 * @since 1.0.0
 */

export { usePopupSettings } from './use-popup-settings';
